export default __webpack_public_path__ + "static/media/Selection_Checkbox_off.07e5ea77.svg";